export const handleApiError = (error) => {
  if (import.meta.env.DEV) console.error('[API Error]', error);
  if (error.response) {
    return `${
      error.response.data.message
        ? error.response.data.message
        : `Internal server error`
    }`;
  } else if (error.request) {
    // Network error
    return "Network error. Please check your connection.";
  } else {
    // Other errors
    return "Something went wrong.";
  }
};
